import { useContext, useEffect, useState } from "react"
import { ArrowsRightLeftIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"

export function Move() {
  const { swapPositions, positions, data } = useContext(MultiContext)
  const [firstPosition, setFirstPosition] = useState()
  const [firstVideoTitle, setFirstVideoTitle] = useState()

  useEffect(() => {
    if (firstPosition) {
      const { title } = data.find((d) => d.uuid === positions[firstPosition])
      if (title) {
        setFirstVideoTitle(title)
      }
    } else {
      setFirstVideoTitle()
    }
  }, [firstPosition, data, positions])

  const onClick = ({ position }) => {
    if (!firstPosition) {
      setFirstPosition(position)
    } else {
      swapPositions(firstPosition, position)
      setFirstPosition()
    }
  }

  return (
    <Panel>
      <Panel.Heading>
        <Panel.HeadingDescription>
          <p>
            {firstPosition ? `Select another position to move to...` : "Select a video to move..."}
          </p>
          {firstVideoTitle && <p>{firstVideoTitle}</p>}
        </Panel.HeadingDescription>
      </Panel.Heading>
      <Panel.Layout
        Icon={ArrowsRightLeftIcon}
        onClick={onClick}
        enabledOptions={firstPosition ? "all" : "active"}
      />
    </Panel>
  )
}
